<template>
    <div>
        
        <v-col cols="12">
            <v-alert
                v-if="informAlert == true"
                close-text="Close Alert"
                dense
                text
                type="success"
                dismissible
                style="text-align: left"
            >
                {{ informText }}
            </v-alert>

            <v-alert
                v-if="informAlert == false"
                close-text="Close Alert"
                dense
                text
                type="error"
                dismissible
                dark
                style="text-align: left"
            >
                {{ informText }}
            </v-alert>
        </v-col>

        
        <v-col cols="12" style="text-align: right;">
            <v-btn color="success" 
                @click="saveData" 
                v-if="!loading && received_in_full_by == '' && (roles.update_import_doc || roles.create_import_doc)"
                style="color:white;margin-right:5px;">
                Save
            </v-btn>
            <v-btn color="success" 
                v-if="loading"
                style="color:white;margin-right:5px;" disabled>
                Saving...
            </v-btn>
            &nbsp;
            <v-btn color="orange" 
                @click="closeDialog" 
                style="color:white;">
                Close
            </v-btn>
        </v-col>

        <v-col cols="12">
            <v-row>
                <v-col cols="6" style="text-align: left;">
                    <table width="100%" style="border: none !important;">
                        <tr>
                            <td style="text-align: left;width: 30%;">Created At:</td>
                            <td style="text-align: left;width: 70%;">{{ warehouseImportData.created_at }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left;">Created By:</td>
                            <td style="text-align: left;">{{ warehouseImportData.created_by }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left;">Total Batches:</td>
                            <td style="text-align: left;">{{ warehouseImportData.total_batches }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left;">Total Products:</td>
                            <td style="text-align: left;">{{ warehouseImportData.total_products }}</td>
                        </tr>
                        <tr>
                            <td style="text-align: left;">Received In Full By:</td>
                            <td style="text-align: left;">
                                <template v-if="received_in_full_by == '' && roles.update_import_doc">
                                    <v-btn
                                        color="info" 
                                        @click="receivedInFullBy">Received In Full</v-btn>
                                </template>
                                <template v-else>
                                    {{ received_in_full_by }}
                                </template>
                            </td>
                        </tr>
                        <tr v-if="warehouseImportData.status == 'Canceled'">
                            <td><b style="color: red;">Canceled</b></td>
                        </tr>
                    </table>
                </v-col>
                <v-col cols="6">     
                    <table width="100%">              
                        <tr>
                            <td style="text-align: left;">Sender:</td>
                            <td style="text-align: left;">
                                <v-text-field
                                    v-model="warehouseImportData.sender"
                                    outlined
                                    dense
                                ></v-text-field>
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align: left;">Warehouse:</td>
                            <td style="text-align: left;">
                                <v-select
                                    :items="listWarehouse"
                                    :item-text="(obj) => obj.warehouse_code"
                                    :item-value="(obj) => obj.warehouse_code"
                                    v-model="warehouseImportData.warehouse_code"
                                    outlined
                                    dense
                                ></v-select>
                            </td>
                        </tr>
                        <tr>
                            <td style="text-align: left;">Note:</td>
                            <td style="text-align: left;">
                                <v-textarea
                                    v-model="warehouseImportData.note"
                                    outlined
                                    dense
                                ></v-textarea>
                            </td>
                        </tr>
                    </table>     
                </v-col>

                <v-col cols="12">
                    <v-btn style="float:right;margin-bottom: 10px;margin-left: 5px;" @click="addRawMaterial" 
                    v-if="received_in_full_by == ''"
                    color="primary">Add Raw Material</v-btn>

                    <v-btn style="float:right;margin-bottom: 10px;" @click="rawMaterialTbl = !rawMaterialTbl" 
                    color="secondary">Show/Hide Raw Material ({{ listRawMaterials.length }})</v-btn>
                    
                    <table width="100%" class="table" v-if="rawMaterialTbl">
                        <tr>
                            <th>Batch No.</th>
                            <th width="25%">Material Code</th>
                            <th>Material Type</th>
                            <th width="20%">Variant</th>
                            <th width="10%">Quantity</th>
                            <th></th>
                        </tr>

                        <tr v-for="(i,indexi) in listRawMaterials" :key="indexi">
                            <td>
                                {{ i.batch_number }}
                            </td>
                            <td>
                                <v-select
                                    :items="raw_materials"
                                    :item-text="(obj) => obj.material_code + ' - ' + obj.material_type"
                                    :item-value="(obj) => obj"
                                    v-model="i.selectedItem"
                                    outlined
                                    dense
                                    v-if="received_in_full_by == ''"
                                    @change="selectRawMaterial(indexi)"
                                ></v-select>
                                <template v-else>{{ i.material_code }}</template>
                            </td>
                            <td>
                                <template v-if="i.selectedItem">
                                    {{ i.selectedItem.material_type }}
                                </template>
                            </td>
                            <td>
                                <v-select
                                    :items="i.selectedItem.variants"
                                    :item-text="(obj) => obj.variant_name"
                                    :item-value="(obj) => obj.variant_id"
                                    v-model="i.variant_id"
                                    v-if="i.selectedItem && received_in_full_by == ''"
                                    outlined
                                    dense
                                ></v-select>
                                <template v-else>{{ i.variant_name }}</template>
                            </td>
                            <td>
                                <v-text-field
                                    type="number"
                                    v-model="i.quantity"
                                    outlined
                                    dense
                                    v-if="received_in_full_by == ''"
                                ></v-text-field>
                                <template v-else>{{ i.quantity }}</template>
                            </td>
                            <td>
                                <v-btn color="red" @click="delRawMaterial(i)" v-if="received_in_full_by == ''">
                                    <v-icon color="white">mdi-delete</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </table>
                </v-col>

                <v-divider class="mx-4" inset horizontal></v-divider>

                <v-col cols="12">
                    <v-btn style="float:right;margin-bottom: 10px;margin-left: 5px;" 
                    v-if="received_in_full_by == ''" @click="addFinishedProduct" 
                    color="primary">Add Finished Product</v-btn>

                    <v-btn style="float:right;margin-bottom: 10px;" @click="finishedProductTbl = !finishedProductTbl" 
                    color="secondary">Show/Hide Finished Product ({{ listFinishedProducts.length }})</v-btn>
                    
                    <table width="100%" class="table" v-if="finishedProductTbl">
                        <tr>
                            <th>Batch No.</th>
                            <th width="25%">Product Code</th>
                            <th>Product Title</th>
                            <th width="20%">Variant</th>
                            <th width="10%">Quantity</th>
                            <th></th>
                        </tr>

                        <tr v-for="(i,indexi) in listFinishedProducts" :key="indexi">
                            <td>
                                {{ i.batch_number }}
                            </td>
                            <td>
                                <v-text-field
                                    type="text"
                                    v-model="i.product_code"
                                    outlined
                                    dense
                                    @keyup="loadProduct(indexi, $event)"
                                    v-if="received_in_full_by == ''"
                                ></v-text-field>
                                <template v-else>{{ i.product_code }}</template>
                                    <v-alert
                                        v-if="i.alertError != ''"
                                        close-text="Close Alert"
                                        dense
                                        text
                                        type="error"
                                        dark
                                        style="text-align: left"
                                    >
                                        {{ i.alertError }}
                                    </v-alert>
                            </td>
                            <td>
                                <template v-if="i.productResponse">
                                    {{ i.productResponse.title }}
                                </template>
                            </td>
                            <td>
                                <v-select
                                    :items="i.productResponse.variants"
                                    :item-text="(obj) => obj.variant_name"
                                    :item-value="(obj) => obj.variant_id"
                                    v-model="i.variant_id"
                                    v-if="i.productResponse && received_in_full_by == ''"
                                    outlined
                                    dense
                                ></v-select>
                                <template v-else>{{ i.variant_name }}</template>
                            </td>
                            <td>
                                <v-text-field
                                    type="number"
                                    v-model="i.quantity"
                                    outlined
                                    dense
                                    v-if="received_in_full_by == ''"
                                ></v-text-field>
                                <template v-else>{{ i.quantity }}</template>
                            </td>
                            <td>
                                <v-btn color="red" @click="delFinishedProduct(i)" v-if="received_in_full_by == ''">
                                    <v-icon color="white">mdi-delete</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </table>
                </v-col>

                <v-col cols="12">
                    <v-btn color="orange" 
                        @click="closeDialog" 
                        style="color:white;float:right">
                        Close
                    </v-btn>
                    <v-btn color="success" 
                        @click="saveData" 
                        v-if="!loading && received_in_full_by == '' && (roles.update_import_doc || roles.create_import_doc)"
                        style="color:white;float:right;margin-right:5px;">
                        Save
                    </v-btn>
                    <v-btn color="success" 
                        v-if="loading"
                        style="color:white;float:right;margin-right:5px;" disabled>
                        Saving...
                    </v-btn>
                </v-col>
            </v-row>
            
        </v-col>
    </div>
</template>

<script>
    import axios from "axios";
    import moment from "moment-timezone";
    import Amplify, { Auth } from "aws-amplify";
    

    Amplify.configure({
    Auth: {
        region: "ap-southeast-1",
        userPoolId: "ap-southeast-1_8vBdk5PAd",
        userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
        mandatorySignIn: true,
    },
    });

    export default {
        name:"DialogWarehouseExport",
        props:{
            selectedItem: Object,
            warehouseList: Array,
            rawMaterialList: Array,
            action:Boolean,
            roles:Object,
        },  
        data: () => ({
            warehouseImportData: {},
            informText: '',
            informAlert: null,
            userId:'',
            loading: false,
            received_in_full_by: '',

            listWarehouse: [],
            raw_materials:[],

            listRawMaterials: [],
            listFinishedProducts: [],

            rawMaterialTbl: true,
            finishedProductTbl: true,

            responseId: null,
            formAction: null,

        }),
        methods:{
            async loadData(){
                var currentSession = await this.$root.$refs.App.currentSession(
                    "warehouseExportEdit-loadData"
                );
                let id = null
                console.log('id: ',this.responseId)

                if(!this.responseId){
                    id = this.selectedItem._id
                }else{
                    id = this.responseId
                }

                this.listRawMaterials = [];
                this.listFinishedProducts = [];
                

                if (currentSession.accessToken) {
                    await axios
                    .get(window.domain + "warehouse-import/" + id, {
                        headers: { Authorization: currentSession.accessToken },
                    })
                    .then((response) => {
                        console.log('response: ',response)
                        this.warehouseImportData = response.data.data.import_doc;
                        console.log('this.warehouseImportData: ',this.warehouseImportData)
                        this.listWarehouse = response.data.data.warehouses
                        this.raw_materials = response.data.data.raw_materials
                        this.warehouseImportData.confirmed_at = moment(this.warehouseImportData.confirmed_at).format("DD/MMM/YYYY - HH:mm:ss");
                        this.warehouseImportData.created_at = moment(this.warehouseImportData.created_at).format("DD/MMM/YYYY - HH:mm:ss");
                        this.warehouseImportData.updated_at = moment(this.warehouseImportData.updated_at).format("DD/MMM/YYYY - HH:mm:ss");
                        this.received_in_full_by = this.warehouseImportData.received_in_full_by

                        if(this.warehouseImportData.finished_products.length > 0){
                            for(let i of this.warehouseImportData.finished_products){
                                let item = {
                                    product_code:i.product_code,
                                    variant_id:i.variant_id,
                                    quantity: i.quantity,
                                    batch_number: i.batch_number,
                                    productResponse: null,
                                    alertError: '',
                                }

                                this.listFinishedProducts.push(item)

                                let indexItem = this.listFinishedProducts.indexOf(item)

                                this.loadProduct(indexItem,null)

                                
                            }
                        }

                        if(this.warehouseImportData.raw_materials.length > 0){
                            for(let i of this.warehouseImportData.raw_materials){
                                let item = {
                                    selectedItem: this.raw_materials.filter(t => t.material_code == i.material_code)[0],
                                    material_code: i.material_code,
                                    variant_id:i.variant_id,
                                    variant_name: this.raw_materials.filter(t => t.material_code == i.material_code)[0].variants.find(t => t.variant_id == i.variant_id).variant_name,
                                    quantity: i.quantity,
                                    batch_number: i.batch_number
                                }

                                this.listRawMaterials.push(item)
                            }
                            console.log('listRawMaterials: ',this.listRawMaterials)
                        }
                    })
                    .catch((error) => {
                        console.log("Error:", error);
                        this.warehouseImportData = {};
                    });
                } else {
                    console.log("undefined warehouseExportEdit-loadData-undefined: ",currentSession);
                }
            }, 

            async saveData(){
                var currentSession = await this.$root.$refs.App.currentSession(
                    "vendor-edit-saveData"
                );
                //console.log('currentSession: ',currentSession.accessToken)
                if (currentSession.accessToken) {
                    
                    let data = {                        
                        "sender": this.warehouseImportData.sender,
                        "note": this.warehouseImportData.note,
                        "warehouse_code": this.warehouseImportData.warehouse_code,
                        "received_in_full_by": this.received_in_full_by,
                        "raw_materials": this.listRawMaterials.map(t => {t.quantity = parseInt(t.quantity);return t}),
                        "finished_products": this.listFinishedProducts.map(t => {t.quantity = parseInt(t.quantity);return t})
                    }

                    console.log('data: ',data)

                    if(!this.formAction){
                        let id = null
                        if(this.responseId){
                            id = this.responseId
                        }else{
                            id = this.selectedItem._id
                        }

                        await fetch(window.domain + "warehouse-import/" + id, {
                            method: "PUT",
                            headers: { Authorization: currentSession.accessToken },
                            body: JSON.stringify(data),
                            })
                            .then((response) => response.json())
                            .then((data) => {
                                console.log("data: ", data);
                                if(data.error_message != ''){
                                    this.informAlert = false
                                    this.informText = data.error_message
                                }

                                this.loadData()
                                this.$root.$refs.warehouseImport.loadData()
                            })
                            .catch((error) => console.log("Error: ", error));
                    }else{
                        await fetch(window.domain + "warehouse-import", {
                        method: "POST",
                        headers: { Authorization: currentSession.accessToken },
                        body: JSON.stringify(data),
                        })
                        .then((response) => response.json())
                        .then((data) => {
                            console.log("data: ", data);
                            if(data.error_message != ''){
                                this.informAlert = false
                                this.informText = data.error_message
                            }else{
                                this.responseId = data.data.import_id
                                this.formAction = false
                                this.loadData(this.responseId)
                                this.$root.$refs.warehouseImport.loadData()
                            }

                        })
                        .catch((error) => console.log("Error: ", error));
                    }
                } else {
                    console.log(
                    "currentSession vendor-edit-saveData-undefined: ",
                    currentSession
                    );
                }
            },

            async receivedInFullBy(){
                this.received_in_full_by = this.userId
                await this.saveData()
            },

            async cancelData(){
                let i = confirm("Are you sure to delete this item?")
                if(i){
                    await this.saveData("cancel")
                }
            },

            addRawMaterial(){
                let item = {
                    selectedItem: null,
                    material_code:'',
                    variant_id:'',
                    quantity:0,
                    batch_number: null,
                }

                this.listRawMaterials.push(item)
            },

            delRawMaterial(item){
                let indexItem = this.listRawMaterials.indexOf(item)

                this.listRawMaterials.splice(indexItem,1)
            },

            selectRawMaterial(index){
                this.listRawMaterials[index].material_code = this.listRawMaterials[index].selectedItem.material_code
            },

            addFinishedProduct(){
                let item = {
                    product_code:'',
                    variant_id:'',
                    quantity: 0,
                    batch_number: null,
                    productResponse: null,
                    alertError:'',
                }

                this.listFinishedProducts.push(item)
            },

            delFinishedProduct(item){
                let indexItem = this.listFinishedProducts.indexOf(item)

                this.listFinishedProducts.splice(indexItem,1)
            },

            async loadProduct(index,e){
                if (!e || (e.keyCode >= 48 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105)) {

                    if(this.listFinishedProducts[index].product_code.length > 18 ){
                        let check = false
                        let temp = null

                        if(this.listFinishedProducts.length > 0){
                            for(let i of this.listFinishedProducts){
                                if(i.productResponse){
                                    if(i.productResponse.product_code == this.listFinishedProducts[index].product_code){
                                        check = true
                                        temp = i.productResponse
                                        break
                                    }
                                }
                            }
                        }
                        
                        if(!check){
                            var currentSession = await this.$root.$refs.App.currentSession(
                                "warehouseExportEdit-loadData"
                            );                    

                            if (currentSession.accessToken) {
                                await axios
                                .get(window.domain + "warehouse-import/get-product-data/" + this.listFinishedProducts[index].product_code, {
                                    headers: { Authorization: currentSession.accessToken },
                                })
                                .then((response) => {
                                    console.log('response: ',response)
                                    if(response.data.error_message != ''){
                                        this.listFinishedProducts[index].alertError = response.data.error_message
                                    }else{
                                        this.listFinishedProducts[index].productResponse = response.data.data
                                        this.listFinishedProducts[index].alertError = ""

                                        
                                        if(this.listFinishedProducts[index].variant_id != "" && this.listFinishedProducts[index].variant_id){
                                            this.listFinishedProducts[index]['variant_name'] = response.data.data.variants.filter(t => t.variant_id == this.listFinishedProducts[index].variant_id)[0].variant_name
                                        }
                                    }
                                })
                                .catch((error) => {
                                    console.log("Error:", error);
                                    this.warehouseImportData = {};
                                });
                            } else {
                                console.log("undefined warehouseExportEdit-loadData-undefined: ",currentSession);
                            }
                        }else{
                            this.listFinishedProducts[index].productResponse = JSON.parse(JSON.stringify(temp))
                        }
                    }
                }
            },

            closeDialog(){
                this.$root.$refs.warehouseImport.turnOffDialog();
            }
        },

        async mounted(){

            try {
                await Auth.currentAuthenticatedUser({ bypassCache: false });

                var currentSession;
                try {
                    currentSession = await Auth.currentSession(); // Auth.currentSession() will automatically refresh the accessToken and idToken if tokens are expired
                    console.log("warehouseExportEdit currentSession: ", currentSession);
                } catch (error) {
                    console.log("warehouseExportEdit error: ", error);
                }

                if (currentSession != undefined) {
                    let username = currentSession.accessToken.payload.username;
                    this.userId = username;
                }   
            } catch (error) {
                console.log("User logged out!");
                this.$router.push("/login");
            }

            this.formAction = JSON.parse(JSON.stringify(this.action))

            if(!this.formAction){
                await this.loadData();
            }else{
                this.listWarehouse = this.warehouseList
                this.raw_materials = this.rawMaterialList
            }
        }
    }
</script>

<style lang="scss" scoped>
.batchInfo, .batchInfoTh, .batchInfoTd {
  border: 1px solid;
  padding:2px;
}

.batchInfo {
  border-collapse: collapse;
}
</style>